import { elements, modifiers } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const block = closest(`.${elements.help}`, button)
    const buttonText = one(`.${elements.button_text}`, button)
    const ariaExpanded = button.getAttribute('aria-expanded')
    const { expand, collapse } = scope(button)
    const newAriaExpanded = ariaExpanded === 'true' ? 'false' : 'true'
    const text = ariaExpanded === 'true' ? expand : collapse

    block.classList.toggle(modifiers.help.open)
    button.title = text
    buttonText.textContent = text
    button.setAttribute('aria-expanded', newAriaExpanded)
  }
})

export default button => {
  onClick.listen(button)
}
